import {
  CREATE_FACILITY,
  FETCH_FACILITY,
  FETCH_FACILITY_LIST,
  SET_FACILITY_PAGINATION,
  UPDATE_FACILITY,
} from "constants/ActionTypes";
import { pageSizeOptions } from "utils/Constant";

const INITIAL_STATE = {
  data: [],
  loading: false,
  facilityList: [],
  facilityRecord: {},
  facilityPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
};

const FacilityReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_FACILITY: {
      let updatedList = state.facilityList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        facilityList: updatedList,
      };
    }

    case UPDATE_FACILITY: {
      return {
        ...state,
        facilityList: state.facilityList?.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
      };
    }

    case FETCH_FACILITY_LIST: {
      return {
        ...state,
        facilityList: action.payload,
      };
    }

    case SET_FACILITY_PAGINATION: {
      return {
        ...state,
        facilityPagination: action.payload,
      };
    }

    case FETCH_FACILITY: {
      return {
        ...state,
        facilityRecord: action.payload,
      };
    }

    default:
      return state;
  }
};

export default FacilityReducer;
